<template>
  <div class="container-fluid">
    <nav v-if="!load" class="navbar navbar-expand-lg navbar-light bg-light mb-3">
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto"></ul>
        <div class="form-inline my-2 my-lg-0">
          <input
            class="form-control mr-sm-2"
            type="search"
            v-model="filter"
            v-on:keyup.enter="goToSearch"
            aria-label="Search"
          />
          <button class="btn btn-outline-success my-2 my-sm-0" @click="goToSearch">
            <span v-if="$route.params.language === 'pt'">Buscar</span>
            <span v-if="$route.params.language === 'en'">Search</span>
            <span v-if="$route.params.language === 'es'">Buscar</span>
          </button>
        </div>
      </div>
    </nav>

    <div v-if="!load && eventsSearch.length < 1" class="alert alert-warning mt-3" role="alert">
      <span v-if="$route.params.language === 'pt'">Nenhum evento encontrado</span>
      <span v-if="$route.params.language === 'en'">No event found</span>
      <span v-if="$route.params.language === 'es'">Ningún evento encontrado</span>
    </div>

    <div v-if="load" class="text-center text-secondary mt-5 mb-3">
      <i class="fas fa-3x fa-spinner fa-pulse"></i>
      <br />
      <span v-if="$route.params.language === 'pt'">Buscando dados</span>
      <span v-if="$route.params.language === 'en'">Buscando dados</span>
      <span v-if="$route.params.language === 'es'">Buscando dados</span>
    </div>

    <div v-if="!load && eventsSearch" class="container">
      <slot-event
        style="margin-top: 10px;"
        v-for="(event, index) in eventsSearch"
        :key="index"
        :time="index"
        :event="event"
      />
    </div>
    <EventInfo :event="eventSelected" />
  </div>
</template>
<script>
import { eventBus } from "../main";
import SlotEvent from "./search/SlotEvent.vue";
import EventInfo from "./event/EventInfo.vue";
import json from "../data/day16.json";
import { HTTP } from "../axios";
var _ = require("lodash");
export default {
  name: "Search",
  data() {
    return {
      times: {},
      events: {},
      filter: "",
      list: [],
      eventsSearch: {},
      load: true,
      eventSelected: undefined
    };
  },
  watch: {
    day() {
      this.getSlots();
    },
    $route(day, language) {
      this.getSlots();
    }
  },
  computed: {
    hasSeach() {
      if (this.eventsSearch.length > 0) {
        return true;
      }

      if (!this.load && this.eventsSearch.length < 1) {
        return false;
      }
    }
  },
  methods: {
    goToSearch() {
      window.location.href =
        "/search/" + this.$route.params.language + "/" + this.filter;
    },
    getSlotsSearch() {
      HTTP.get(
        "search/e984dc69-0e1b-4b23-b5e9-9158d8ad9533/" +
          this.filter +
          "/" +
          this.$route.params.language
      ).then(response => {
        this.eventsSearch = response.data.slots;
        this.load = false;
      });
    }
  },
  components: {
    SlotEvent,
    EventInfo
  },
  mounted() {
    this.filter = this.$route.params.term;
    this.getSlotsSearch();
  },
  created() {
    eventBus.$on("selectEvent", eventSelected => {
      this.eventSelected = eventSelected;
    });
  }
};
</script>

<style scoped>
/* .time-column{
    display: flex;
    align-items: center;
    justify-content: center;
  } */
.time-event {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  width: 100%;
}
.event {
  width: 100%;
  display: inline-block;
  vertical-align: top;
  margin: 12px 6px !important;
}
@media (min-width: 770px) {
  .event {
    width: 32%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue